import { type ReactNode } from 'react';

interface LabelProps {
  children: ReactNode;
  name: string;
}

const Label = ({ children, name }: LabelProps) => (
  <label className="fw-bold" htmlFor={name}>
    {children}
  </label>
);

export default Label;
